import { useEffect } from "react";

function setMeta(attribute: "name" | "property", key: string, value: string) {
  let meta = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attribute, key);
    document.head.append(meta);
  }
  meta.content = value;
}

export function usePublicPageMetadata(page: { title: string; description: string; canonical: string; ogType?: string }) {
  useEffect(() => {
    const canonical = page.canonical;
    document.title = page.title;
    setMeta("name", "description", page.description);
    setMeta("name", "robots", "index, follow");
    setMeta("property", "og:type", page.ogType ?? "website");
    setMeta("property", "og:title", page.title);
    setMeta("property", "og:description", page.description);
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:title", page.title);
    setMeta("name", "twitter:description", page.description);
    let canonicalLink = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.append(canonicalLink);
    }
    canonicalLink.href = canonical;
  }, [page]);
}
